import { SearchAddress } from "components/AutoAddress/api/addressApi";
import { AddressState } from "pages/HardshipApplication/reducer/types";

const getAutoAddressString = (address: SearchAddress) =>
  `${address.AddressLine}, ${address.Locality}, ${address.State} ${address.Postcode}`;

const getManualAddressString = (address: AddressState, region: string) =>
  `${address.streetAddress}, ${address.suburb}, ${
    region === "AU" ? address.state : address.city // has to be || and not ?? because it will be an empty string
  } ${address.postCode}`;

export const getAddressString = (address: AddressState, region: string) =>
  address.mode === "auto"
    ? getAutoAddressString(address.auto)
    : getManualAddressString(address, region);
